import { z } from 'zod';
import {
  mmCombinedSortByValues,
  mmStatusValues,
  typeOfMaintenanceValues,
} from 'src/apis/iip-service/mappings';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import {
  optionalDefault,
  preprocessAsArray,
} from 'src/components/form/zod-utilities';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { operatorOptionSchema } from 'src/pages/market-messages/maintenance-messages/overview/operator-searchable-multi-select';

const sortByPublicationDateTimeDefault = 'PUBLICATION_DATE_TIME_DESC';

const schema = z
  .object({
    sortBy: z
      .enum(mmCombinedSortByValues)
      .default(sortByPublicationDateTimeDefault),
    operatorId: z.preprocess(
      preprocessAsArray,
      z.array(operatorOptionSchema).default([])
    ),
    eventPeriodFrom: z.string().nullable().default(null),
    eventPeriodTo: z.string().nullable().default(null),
    publicationDateTimeFrom: z.string().nullable().default(null),
    publicationDateTimeTo: z.string().nullable().default(null),
    identifier: z.string().max(100).nullable().default(null),
    status: z.preprocess(
      optionalDefault(['ACTIVE']),
      z.preprocess(preprocessAsArray, z.array(z.enum(mmStatusValues)))
    ),
    typeOfMaintenance: z
      .preprocess(preprocessAsArray, z.array(z.enum(typeOfMaintenanceValues)))
      .default([]),
  })
  .merge(getPaginationSchema());

export const useMmPageParams = () => {
  return usePageParamsFromSchema(schema, {
    filters: {
      operatorId: { label: 'Operator' },
      eventPeriodFrom: { label: 'Event Period' },
      eventPeriodTo: { label: 'Event Period' },
      publicationDateTimeFrom: { label: 'Publication Date' },
      publicationDateTimeTo: { label: 'Publication Date' },
      identifier: { label: 'Message ID' },
      status: { label: 'Status' },
      sortBy: { label: 'Sort Messages by' },
      typeOfMaintenance: { label: 'Maintenance Type' },
    },
  });
};

export type MmPageParams = ReturnType<typeof useMmPageParams>;
